import React, { useEffect } from "react";
import StepWrapper from "./StepWrapper";
import { Form, FormControl, InputGroup, ListGroup } from "react-bootstrap";
import { getFullName } from "../../../../Modules/utils/fullname";

const SelectAgentStep = ({
  data,
  agents = [],
  onSubmit,
  totalSteps,
  loadAgents,
  isEditing = false,
}) => {
  const [query, setQuery] = React.useState("");
  const filtered = query
    ? agents.filter(
        (a) =>
          a.firstName?.toLowerCase().includes(query.toLowerCase()) ||
          a.lastName?.toLowerCase().includes(query.toLowerCase())
      )
    : agents;

  useEffect(() => {
    if (!agents?.length) loadAgents();
  }, []);

  return (
    <StepWrapper
      step={data.step}
      total={totalSteps}
      disableNext={!data.agent}
      onPrev={() => onSubmit({ step: data.step - 1 })}
      onNext={() => onSubmit({ step: data.step + 1 })}
    >
      {isEditing ? (
        <>
          <Form.Label>Field Executive</Form.Label>
          <ListGroup.Item action active={true} onClick={() => onSubmit({})}>
            {getFullName(data.agent)}
          </ListGroup.Item>
          <div style={{ fontSize: "10px", color: "#888", marginTop: "10px" }}>
            *Field Executive modification not allowed
          </div>
        </>
      ) : (
        <>
          <Form.Label>
            {data?.agent?._id ? (
              <>
                Selected FE: <b>{getFullName(data.agent)}</b>
              </>
            ) : (
              "Select Field Executive"
            )}
          </Form.Label>
          <InputGroup className="mb-2">
            <FormControl
              placeholder="Search..."
              value={query}
              onChange={(e) => setQuery(e.target.value)}
              autoFocus
            />
          </InputGroup>
          {filtered?.length ? (
            <ListGroup>
              {filtered.map((a) => (
                <ListGroup.Item
                  key={a._id}
                  action
                  active={a._id === data.agent?._id}
                  onClick={() =>
                    onSubmit({
                      agent: a,
                      cod: {
                        ...(data.cod || {}),
                        deliveryRate: a.agent?.rates?.delivery,
                        pickupRate: a.agent?.rates?.pickup,
                      },
                    })
                  }
                >
                  {getFullName(a)}
                </ListGroup.Item>
              ))}
            </ListGroup>
          ) : null}
        </>
      )}
    </StepWrapper>
  );
};

export default SelectAgentStep;
